/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { BCode } from '@src/app/model/bcode';

@Injectable({
    providedIn: 'root'
})
export class BCodeService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl() {
        return this.getAjaxPath('budgets/bcodes');
    }

    protected cache: BCode[];
    protected typeString = 'Budget Code';
}
